import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { contactInfoZodObject } from "@@/shared/locations/contact-info";
import { payRequestReferencesZodObject } from "@@/shared/pay-requests/events/_pay-request-references";
import { payRequestIdZodSchema } from "@@/shared/pay-requests/pay-request-id";
import { payRequestItemZodSchema } from "@@/shared/pay-requests/pay-request-item";
import { payRequestRecipientZodSchema } from "@@/shared/pay-requests/pay-request-recipient";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const initiatePayRequestCommandZodObject = z.object({
    _id: idZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("INITIATE_PAY_REQUEST_COMMAND"),
    /**
     * References, what is the pay request created for?
     * what order? order events? provider? e.t.c.
     */
    payRequestFor: payRequestReferencesZodObject,
    /**
     * Contact info for payers of the pay request
     * a notification will (have) be(en) sent to these contacts
     */
    recipients: z.array(payRequestRecipientZodSchema).min(1),
    payRequestItems: z.array(payRequestItemZodSchema).min(1),
    orderContactInfo: contactInfoZodObject,
});

type InitiatePayRequestCommand = z.infer<
    typeof initiatePayRequestCommandZodObject
>;

type FactoryParams = Except<
    InitiatePayRequestCommand,
    "_id" | "_type" | "_createdAt"
>;
const initiatePayRequestCommandFactory = (params: FactoryParams) => {
    const initiatePayRequestCommand: InitiatePayRequestCommand = {
        ...params,
        _id: generateId({
            prefix: "initiate_request_command__",
        }),
        _type: "INITIATE_PAY_REQUEST_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return initiatePayRequestCommand;
};

const initiatePayRequestCommandResponseZodObject = z.object({
    _type: z.literal("INITIATE_PAY_REQUEST_COMMAND_RESPONSE"),
    payRequestId: payRequestIdZodSchema,
});
type InitiatePayRequestCommandResponse = z.infer<
    typeof initiatePayRequestCommandResponseZodObject
>;
const initiatePayRequestCommandResponseZodSchema: z.ZodSchema<InitiatePayRequestCommandResponse> =
    initiatePayRequestCommandResponseZodObject;

export {
    initiatePayRequestCommandFactory,
    initiatePayRequestCommandResponseZodSchema,
    initiatePayRequestCommandZodObject,
};
export type { InitiatePayRequestCommand, InitiatePayRequestCommandResponse };
